import request from "../shared/http";

class InsightsService {
  static async getDashboard() {
    const { data } = await request.get("/insights/dashboard");
    return data;
  }

  static async getLatest() {
    const { data } = await request.get("/insights/latest");
    return data;
  }

  static async refreshAll(window = "30d") {
    const { data } = await request.post("/insights/refresh", { window });
    return data;
  }

  static async refreshOne(id, window = "30d") {
    const { data } = await request.post(`/insights/${id}/refresh`, { window });
    return data;
  }

  static async getHistory(id, limit = 10) {
    const { data } = await request.get(`/insights/${id}/history`, { params: { limit } });
    return data;
  }
}

export default InsightsService;
